export const environment = {
  
  bearerToken:
    "",
};
